<template>
    <div>
      <v-icon x-large @click="dialog=true">mdi-magnify</v-icon>
      
      
      <v-dialog
        v-model="dialog"
        scrollable  
        persistent :overlay="false"
      
        transition="dialog-transition"
      >
      <v-card>
          <v-card-text>
   <v-img v-if="showState == 'contain'" height="100%" contain :src="imageURL" />
   <v-img v-if="showState == 'full'" :src="imageURL" />

          </v-card-text>
          <v-divider
                class=""
              ></v-divider>
             
          <v-card-actions>
               <v-spacer></v-spacer>  <v-btn
              text
              color="blue"
              v-if="showState == 'contain'"
              outlined
              @click="showState='full'"
            >
             Show Full Size
            </v-btn>
            <v-btn
              text
              color="blue"
              v-if="showState !== 'contain'"
              outlined
              @click="showState='contain'"
            >
             Fit Image to Screen
            </v-btn>
            <v-btn
              text
              color="blue"
              
              outlined
              @click="dialog=false"
            >
             Done
            </v-btn>
          </v-card-actions>
        </v-card>
       
        
      </v-dialog>
      </div>
</template>

<script>
    export default {
  name: 'image-viewer',
  components: {
   
  },
   props: ['source'],
  data() {
   
    return {
      dialog: false,
      showState: 'contain'
    }
  },
  computed: {
  imageURL () {
    return require('@/assets/images/' + this.source)
    // The path could be '../assets/img.png', etc., which depends on where your vue file is
  }
}
}
</script>

<style>
</style>